// language=GraphQL
export const ALL_PASSPORT_CONFIGS_QUERY = `query Query {
  passportConfigs: travelPricingPassportConfigs {
    id
    passportOnly
  }
}`

// language=GraphQL
export const SINGLE_PASSPORT_CONFIG_QUERY = `query Query($id: ID!) {
  passportConfig: travelPricingPassportConfig(id: $id) {
    id
    passportOnly
  }
}`

// language=GraphQL
export const CREATE_PASSPORT_CONFIG_MUTATION = `
  mutation Mutation($input: CreateTravelPricingPassportConfigInput) {
    passportConfig: createTravelPricingPassportConfig(input: $input) {
      id
      passportOnly
    }
  }`

// language=GraphQL
export const UPDATE_PASSPORT_CONFIG_MUTATION = `
  mutation Mutation($input: UpdateTravelPricingPassportConfigInput) {
    passportConfig: updateTravelPricingPassportConfig(input: $input) {
      id
      passportOnly
    }
  }`

// language=GraphQL
export const DELETE_PASSPORT_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingPassportConfigInput) {
    deleteTravelPricingPassportConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PASSPORT_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingPassportConfigInput) {
    forceDeleteTravelPricingPassportConfig(input: $input) {
      success
    }
  }`
// language=GraphQL
export const PASSPORT_CONFIGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricings: Boolean = false) {
  groupedDependents: travelPricingPassportConfigDependents(id: $id) {
    travelPricings @include(if: $withTravelPricings) {
      id
      isTravelDocumentationAvailable
    }
  }
}`
